import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  pointerWithin,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { ReactNode, useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useAppSelector from "@/core/helpers/useAppSelector";
import { memoizedItemSelector } from "@/domains/inventory/slice";
import InventoryGridItemPreview from "@/domains/inventory/components/dndkit/InventoryGridItemPreview";

type Props = {
  children: ReactNode;
};

export default function InventoryDndContextWrapperContainer({ children }: Props) {
  const [activeItem, setActiveItem] = useState<InventoryItem | null>(null);
  const memoizedItem = useAppSelector(memoizedItemSelector);

  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 5,
    },
  });

  const sensors = useSensors(pointerSensor);

  const handleDragStart = useCallback((event) => {
    setActiveItem(event.active.data.current);
  }, []);

  const handleDragEnd = useCallback(() => {
    setActiveItem(null);
  }, []);

  useEffect(() => {
    if (memoizedItem) {
      setActiveItem(memoizedItem);
    }
  }, [memoizedItem]);

  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      // collisionDetection={pointerWithin}
      collisionDetection={(args) => {
        const collisions = pointerWithin(args);
        const itemCollision = collisions.find((c) => String(c.id).startsWith("item"));
        return itemCollision ? [itemCollision] : collisions;
      }}
    >
      {createPortal(
        <DragOverlay
          dropAnimation={{
            duration: 200,
            easing: "ease",
          }}
          zIndex={9999}
          modifiers={[]} // можно кастомизировать позиционирование, если надо
        >
          {activeItem ? <InventoryGridItemPreview item={activeItem} /> : null}
        </DragOverlay>,
        document.body,
      )}
      {children}
    </DndContext>
  );
}
